import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface PhaseMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allPhaseMaster: [] | null | any;
}
const initialState: PhaseMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allPhaseMaster: null
};
export const phaseMasterSlice = createSlice({
  name: 'phaseMaster',
  initialState,
  reducers: {
    setAllPhaseMaster: (state, action) => {
      state.allPhaseMaster = action.payload.data;
    },
    setPhaseMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllPhaseMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllPhaseMaster, setPhaseMaster, setAllPhaseMasterBySearch,reset } = phaseMasterSlice.actions;
export const allPhaseMasterDetails = (state: RootState) => state.phaseMaster.allPhaseMaster;
export const getAllPhaseMasterDetails = (state: RootState) => state.phaseMaster.data;
export const getPhaseMasterTotalRecords=(state:RootState)=>state.phaseMaster.totalRecords;
export const getAllPhaseMasterBySearch = (state: RootState) => state.phaseMaster.data;
export default phaseMasterSlice.reducer;